<template>
    <div>
        <div class="box">
            <!-- 内容区域 -->
            <div class="box_content">
                <TabTime
                    @onChangeTime="onChangeTime"
                    :titleText="'业务总营收数据统计'" />
                <!-- 日期选择 -->
                <div class="title">
                    <span class="blue-title"></span>
                    <span class="title-text">营收数据</span>
                </div>
                <div class="data-item">
                    <div class="detail-item">
                        <div class="item-lev leline">
                            <div class="number">
                                {{ (tapTotalData.totalRevenue / 10000).toFixed(2) }}
                                <span class="danwei">万元</span>
                            </div>
                        </div>
                        <div class="total-mo">营收总额</div>
                    </div>
                    <div class="small-line"></div>

                    <div class="detail-item">
                        <div class="item-lev">
                            <div class="number">
                                {{ (tapTotalData.totalUserNum / 10000).toFixed(2) }}
                                <span class="danwei">万人</span>
                            </div>
                        </div>
                        <div class="total-mo">用户总量</div>
                    </div>
                </div>
                <div class="title">
                    <span class="blue-title"></span>
                    <span class="title-text">各类业务营收占比</span>
                </div>
                <div class="chart-container">
                    <div class="pie-chart" ref="pieChart"></div>
                    <div class="legend">
                        <ul>
                            <li v-for="(item, index) in pieData" :key="index">
                                <span
                                    class="legend-color"
                                    :style="{ backgroundColor: item.color }"></span>
                                <span class="legend-name">{{ item.name }}</span>
                                <span class="legend-percent"
                                    >{{ parseInt(item.percent) }}%</span
                                >
                                <span class="legend-value"
                                    >{{ item.value }}万元</span
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="chart-container">
          <div id="pieChart" class="chart"></div>
        </div> -->

            <!-- <TabTime @onChangeTime="onChangeTime" :currentIndex="6" :titleText="'东秦供水数据统计'" />
        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">营收数据</span>
        </div> -->
            <!-- 详细六个flex排列 -->
            <!-- <div class="data-item3">
            <div class="item-six">
                <div class="item-mar">
                    <div ><span class="number">210.71</span><span class="danwei">方</span></div>
                    <div class="total-mo">供水量</div>
                </div>
                <div class="tooline2"></div>
                <div>
                    <div><span class="number">32212</span><span class="danwei"></span></div>
                    <div class="total-mo">累计供水量</div>
                </div>
            </div>
        </div>
        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">东秦供水营收数据增长趋势</span>
        </div>
        <div>
            <GasPageVue></GasPageVue>
        </div>

        <TabTime @onChangeTime="onChangeTime" :currentIndex="7" :titleText="'智慧供热营收数据'" />
        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">营收数据</span>
        </div> -->
            <!-- 详细六个flex排列 -->
            <!-- <div class="data-item2">
            <div class="item-six">
                <div>
                    <div><span class="number">210.71</span><span class="danwei">万</span></div>
                    <div class="total-mo">营收额</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div ><span class="number">210.71</span><span class="danwei">亿</span></div>
                    <div class="total-mo">累计营收额</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">累计用户量</div>
                </div>
            </div>
            <div class="item-six">
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">新增用户量</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">供热量</div>
                </div>
                <div>
                    <div><span class="number">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="danwei"></span></div>
                    <div class="total-mo"></div>
                </div>
            </div>
        </div>
        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">智慧供热营收数据增长趋势</span>
        </div>
        <div>
            <CarPageVue></CarPageVue>
        </div>


        <TabTime @onChangeTime="onChangeTime" :currentIndex="8" :titleText="'智慧商砼'" />
        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">营收数据</span>
        </div> -->
            <!-- 详细六个flex排列 -->
            <!-- <div class="data-item2">
            <div class="item-six">
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">销量</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div ><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">累计销量</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">产值</div>
                </div>
            </div>
            <div class="item-six">
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">累计产值</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">采购值</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div><span class="number">1229</span><span class="danwei"></span></div>
                    <div class="total-mo">总采购量</div>
                </div>
            </div>
        </div>

        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">智慧商砼营收数据增长趋势</span>
        </div>
        <div>
            <shangtong></shangtong>
        </div> -->
        </div>
    </div>
</template>

<script>
// import Test1 from './Test1.vue'
// import GasPageVue from './GasPage.vue';
// import WaterPageVue from './WaterPage.vue';
// import TripPageVue from './TripPage.vue';
// import CarPageVue from './CarPage.vue';
// import shangtong from './shangtong.vue';
import TabTime from './tabTime.vue'
// import api from '../api/index'
import {shortcuts} from '../utils/index'
import * as echarts from 'echarts'

export default {
  components:{
        TabTime
  },
  data() {
    return {
      currentView: 'CityShow',
      currentTime: '',
      formattedDate: "",
      currentDay: "",
      tapTotalData: {} ,
      chart: null,
      legendData: [],
      pieData:[],
  }
},
  mounted() {
    this.getCurrentDate();
    this.updateTime();
    this.tapTotalApi(shortcuts(1));
    // 初始化图表
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    // 组件销毁时销毁图表
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    updateTime() {
      // 使用 setInterval 每秒更新一次时间
      setInterval(() => {
        const now = new Date();
        this.currentTime = now.toLocaleTimeString();
      }, 1000);
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const daysOfWeek = ["日", "一", "二", "三", "四", "五", "六"];
      const dayOfWeek = "星期" + daysOfWeek[date.getDay()];
      this.formattedDate = `${year}-${month}-${day}`;
      this.currentDay = dayOfWeek;
    },
   onChangeTime(message) {
     console.log('日期选择变化:', message.date);
      this.tapTotalApi(message.date);
   },
     async tapTotalApi(date) {
      try {
        const [startDate, endDate] = date;

        const formatDate = (dateObj) => {
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        // 使用GET请求并直接拼接URL参数
        const response = await fetch(
          `http://117.33.227.88:8788/overview/summary?startDay=${formatDate(startDate)}&endDay=${formatDate(endDate)}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        this.processIncomeData(res);

      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
     processIncomeData(res) {
      const data = res || {};
        this.tapTotalData = {
          totalRevenue: data.totalRevenue,
          totalUserNum: data.totalUserNum
       };
     this.pieData = [
        { value: ((data.tingcheRevenue || 0)/10000).toFixed(2), name: '停车系统', color: '#3B5B95' ,percent:data.tingchePercent},
        { value: ((data.waterRevenue || 0)/10000).toFixed(2), name: '自来水', color: '#19D084' ,percent:data.waterPercent},
        { value: ((data.tourismRevenue || 0)/10000).toFixed(2), name: '洽川旅游', color: '#2F72FA' ,percent:data.tourismPercent},
        // { value: data.gasRevenue || 0, name: '燃气系统', color: '#5EE8FD' },
        // { value: data.heatRevenue || 0, name: '智能供热', color: '#8D57F9' }
      ];

    this.updateChart();
   },
   initChart() {
      const pieChartDom = this.$refs.pieChart;
      this.chart = echarts.init(pieChartDom);
      const option = {
        title: {
        //   text: '营收占比分析',
          left: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return `${params.name}<br/>金额: ${(params.value)}万元<br/>占比: ${params.data.percent}%`;
          }
        },
        color: ['#3B5B95', '#19D084', '#5EE8FD', '#2F72FA', '#8D57F9'],
        series: [
          {
            type: 'pie',
            name: '营收占比',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 1
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'normal',
                formatter: '{b}\n{c}万元\n({d}%)',
                color: '#fff'
              }
            },
            labelLine: {
              show: false
            },
            data: this.pieData
          }
        ]
      };
      this.chart.setOption(option);
    },
    updateChart() {
      if (!this.chart) return;
      const option = {
        series: [
          {
            type: 'pie',
            data: this.pieData
          }
        ]
      };
      this.chart.setOption(option);
    }
}
}
</script>


<style scoped src="./css/total.css"></style>
